import { InjectionToken } from '@angular/core';

/**
 * Injection token for options object
 */
export const SUNEDITOR_OPTIONS = new InjectionToken('SUNEDITOR_OPTIONS');
